module.exports = __webpack_public_path__ + "media/asset/images/1_KV/ITRI_cover_EN-b6073eca8880c159cef0d04cbf34f8a1.png";